export const theme = {
  colors: {
    primary: {
      main: '#FAAF90',    // Warm peach/salmon - Primary actions, active states
      light: '#FCC4AD',   // Lighter peach - Hover states
      dark: '#E59873',    // Darker peach - Active/pressed states
    },
    secondary: {
      main: '#6B9BD1',    // Soft blue - Secondary actions, links
      light: '#8FB4E3',   // Light blue - Hover states
      dark: '#4A7FB8',    // Dark blue - Active states
    },
    status: {
      success: '#7BC67E', // Soft green - Success states, healthy status
      warning: '#F5A623', // Amber - Warning states, attention needed
      error: '#d32f2f',   // Red - Error states, critical alerts
      info: '#6B9BD1',    // Blue - Information states
    },
    background: {
      default: '#FFF8F5', // Light peach tint - Main background
      paper: '#FFFFFF',   // Pure white - Cards, panels
      dark: '#1a1a1a',    // Dark mode background
      darkPaper: '#2a2a2a', // Dark mode cards
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',   // Near black - Main text
      secondary: 'rgba(0, 0, 0, 0.6)',  // Gray - Secondary text
      darkPrimary: '#ffffff',            // Dark mode primary text
      darkSecondary: '#cccccc',         // Dark mode secondary text
    },
    border: {
      light: 'rgba(228, 165, 128, 0.2)', // Peach-tinted borders
      dark: '#3a3a3a',                   // Dark mode borders
    }
  },
  fonts: {
    primary: "'Tenor Sans', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    mono: 'source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace',
  },
  sidebar: {
    collapsedWidth: '64px',
    expandedWidth: '256px',
    animationDuration: '300ms',
    itemHeight: '48px',
    childItemHeight: '32px',
    itemPaddingX: '16px',
    childItemPaddingLeft: '48px',
  },
  commandPalette: {
    maxWidth: '672px',
    maxHeight: '384px',
    borderRadius: '12px',
    inputHeight: '56px',
    inputFontSize: '18px',
    itemHeight: '48px',
  },
  widget: {
    borderRadius: '12px',
    padding: '24px',
    boxShadow: '0 2px 10px rgba(228, 165, 128, 0.1)',
    hoverBoxShadow: '0 4px 20px rgba(228, 165, 128, 0.15)',
  }
};